import {createSelector} from '@reduxjs/toolkit'

export const currentCollectorSelector = createSelector(
    [state => state.collectorApplicationData],
    (collectorAppData) => {
        if(collectorAppData.collectors && 
            collectorAppData.currentCollectorIndex >= 0 && 
            collectorAppData.currentCollectorIndex < collectorAppData.collectors.length) {
                let currentCollector = collectorAppData.collectors[collectorAppData.currentCollectorIndex]
                return currentCollector
            }

        return {}
    }
)

export const currentAgentApplicationSelector = createSelector(
    [state => state.additionalApplications],
    (additionalApplications) => {
        return additionalApplications.agentApplications.find(
            app => app.id === additionalApplications.currentAgentApplicationId)
    }
)


export const currentAgentCachePropertiesSelector = createSelector(
    state => state.additionalApplications?.agentCacheProperties,
    (agentCacheProperties) => {
        return agentCacheProperties || {}
    }
)

